var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-text',[_c('div',{staticClass:"d-flex"},[_c('v-avatar',[_c('img',{attrs:{"src":_vm.reported.avatar_permanent_url}})]),_c('div',{staticClass:"ml-3"},[_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.reported.full_name))]),_c('label',{staticClass:"d-block"},[_vm._v(_vm._s(_vm.reported.email))])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }